export function fix2digit(value) {
  return parseFloat(parseFloat(value).toFixed(2));
}
